import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_TENURE = 0;
const DEFAULT_MAX_TENURE = 2;

export const tenureDescriptor = defineFilter({
  definition: {
    id: FilterId.TENURE,
    name: 'Tenure',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_TENURE,
    max: DEFAULT_MAX_TENURE,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_TENURE, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(DEFAULT_MIN_TENURE, DEFAULT_MAX_TENURE),
});
